import { TableRow, Layout, SlideoutDecorator } from "@mcleod/components";
import { AutogenLayoutCRMMultiSelectErrorSlideout } from "./autogen/AutogenLayoutCRMMultiSelectErrorSlideout";
import { ModelRow } from "@mcleod/core";

const layoutPath = "lme/crm/CRMMultiSelectErrorSlideout";

export class CRMMultiSelectErrorSlideout extends AutogenLayoutCRMMultiSelectErrorSlideout {

    public static async showSlideout(failedRows: ModelRow[]) {
        const layout = Layout.getLayout(layoutPath) as CRMMultiSelectErrorSlideout;
        const hasFailures = failedRows.length > 0;
        return new SlideoutDecorator({
            title: "Update Error Details",
            layout: layout,
            width: "65%",
            fillVerticalSpace: true,
            doAfterSlideIn: async (decorator: SlideoutDecorator) => {
                layout.panelFailed.visible = hasFailures;
                if (hasFailures) {
                    layout.tableFailed.displayData(null, failedRows, 0);
                    layout.labelFailedCount.text = failedRows.length.toString();
                }
            },
            onClose: async (cancelled: boolean) => {
                layout.slideOut();
            }
        });
    }
}